export function normalizeCategoryName(value) {
  return String(value == null ? '' : value).trim();
}

export function categoryExists(options, value) {
  const needle = normalizeCategoryName(value).toLowerCase();
  if (!needle) return false;
  return (options || []).some((opt) => normalizeCategoryName(opt).toLowerCase() === needle);
}

export function isNewCategoryOption(options, option) {
  const value = normalizeCategoryName(option);
  if (!value) return false;
  return !categoryExists(options, value);
}

export function filterCategoryOptions(options, params) {
  const list = Array.isArray(options) ? options : [];
  const input = normalizeCategoryName(params?.inputValue);
  const needle = input.toLowerCase();
  const filtered = needle
    ? list.filter((opt) => String(opt).toLowerCase().includes(needle))
    : list.slice();
  if (input && !categoryExists(list, input)) filtered.push(input);
  return filtered;
}
